<template>
  <div>
    <Edit :item="currentItem" :close="closeEdit" :onSubmit="onSubmit" />
    <div class="filters row" style="margin-top: 0">
      <div class="col-1-3">
        <!--<span class="filters__search">-->
        <!--<input type="text" name="" value="" placeholder="Filtrar por nome">-->
        <!--<fa-icon icon="search"/>-->
        <!--</span>-->
      </div>
      <div class="col-2-3">
        <div class="pull-right">
          <button v-on:click="openCreate" class="button button-success button-block">
            <fa-icon icon="plus" />
            Criar
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <datatable :columns="table.columns" :data="items" class="table table-hover">
        <template slot-scope="{ row }">
          <tr>
            <td>{{ row.id }}</td>
            <td>{{ row.descricao }}</td>
            <td>{{ row.nivel }}</td>
            <td>{{ row.root_id ?? "Principal" }}</td>
            <td>{{ yesNoValue(row.obrigatorio) }}</td>
            <td class="actions">
              <button type="button" class="button button-primary" v-on:click="openEdit(row)">
                <fa-icon icon="pencil-alt" />
              </button>
              <button type="button" name="button" v-on:click="deleteConfirm(row.id)" class="button button-error">
                <fa-icon icon="trash-alt" />
              </button>
            </td>
          </tr>
        </template>
      </datatable>
    </div>
    <div style="justify-content: center; display: flex">
      <pagination :data="table.paginator" :limit="5" @pagination-change-page="getData"></pagination>
    </div>
  </div>
</template>

<script>
import clone from "just-clone";
import {
  schemaBooleanSelect,
  schemaNumber,
  schemaTextField
} from "@/helpers/form";
import { yesNoRepresentation } from "@/helpers/transformers";
import { get, post, put, del } from "@/helpers/apiRequest";
import Edit from "./Edit";

const initialItem = {
  descricao: "",
  nivel: 2,
  root_id: 1,
  obrigatorio: 0,
};

export default {
  name: "MotivoAbertura",
  components: {
    Edit
  },
  data() {
    return {
      currentItem: {},
      niveis: [],
      loading: false,
      items: [],
      table: {
        columns: [
          { label: "ID", field: "id", sortable: false },
          { label: "DESCRIÇÃO", field: "descricao", sortable: false },
          { label: "NIVEL", field: "nivel", sortable: false },
          { label: "ID do Tipo Ticket Pai", field: "root_id", sortable: false },
          { label: "OBRIGATORIO", field: "obrigatorio", sortable: false, },
          { label: "AÇÕES", field: "actions", sortable: false },
        ],
        paginator: {},
      },
      formInputs: {
        descricao: schemaTextField('Descrição', true, 6),
        nivel: schemaNumber('Nível', 1, 4, true),
        root_id: schemaNumber('ID do Tipo Ticket Pai', 1, 4, false),
        obrigatorio: schemaBooleanSelect('Obrigatorio', 1, 4, true),
      },
    };
  },
  methods: {
    getData(page) {
      get(`/admin/sac/ticket/motivo/abertura?page=${page}`)
        .then(json => {
          this.items = json.itens;
          this.table.paginator = json.paginator;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    openEdit(item) {
      this.currentItem = clone(item);
      this.$modal.show("ticketMotivoAberturaEdit");
    },
    openCreate() {
      this.currentItem = clone(initialItem);
      this.$modal.show("ticketMotivoAberturaEdit");
    },
    closeEdit() {
      this.$modal.hide("ticketMotivoAberturaEdit");
    },
    deleteConfirm(id) {
      this.$swal({
        title: "Confirma Remover?",
        text: "Essa ação não poderá ser desfeita",
        showCancelButton: true,
        icon: "warning",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      })
        .then((res) => {
          if (res.value) {
            this.loading = true;
            del(`/admin/sac/ticket/motivo/abertura/${id}`)
              .then((json) => {
                this.loading = false;
                this.getData(this.table.paginator.current_page);
                this.$swal({
                  title: "Removido com sucesso",
                  text: json.message,
                  showCancelButton: false,
                  cancelButtonText: "Fechar",
                  showConfirmButton: true,
                  icon: "success",
                });
              })
              .catch((err) => {
                this.loading = false;
                this.$swal({
                  title: "Falha ao remover",
                  icon: "error",
                });
              });
          }
        })
        .catch(() => { });
    },
    onSubmit(item) {
      this.loading = true;
      const request = this.request(item);
      request
        .then((json) => {
          this.closeEdit();
          this.getData();
          this.$swal({
            title: "Salvo com sucesso",
            text: json.message,
            showCancelButton: false,
            cancelButtonText: "Fechar",
            showConfirmButton: true,
            icon: "success",
          });
        })
        .catch((error) => {
          this.$swal({
            title: "Falha ao Salvar",
            text: error.message,
            showCancelButton: true,
            cancelButtonText: "Fechar",
            showConfirmButton: false,
            icon: "error",
          });
        });
      return request;
    },
    request(item) {
      if (item.id) {
        return put(`/admin/sac/ticket/motivo/abertura/${item.id}`, item);
      }
      return post(`/admin/sac/ticket/motivo/abertura`, item);
    },
    yesNoValue(value) {
      return yesNoRepresentation(value);
    },
  },
  beforeMount() {
    this.getData(1);
  }
};
</script>
